import { gql } from '@apollo/client';

export default gql`
  mutation CreateProductComponentOtherMutation(
    $productComponentOther: ProductComponentOtherInput!
  ) {
    createProductComponentOther(
      input: { productComponentOther: $productComponentOther }
    ) {
      productComponentOther {
        id
      }
    }
  }
`;
